import { Modal, Button } from "react-bootstrap";

export default function ConfirmationModal({
  show,
  title,
  body,
  handleClose = () => {},
  handlerYes = () => {},
  handlerNo = () => {},
  btnYesText = "Yes",
  btnNoText,
}) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{body}</div>
      </Modal.Body>

      <Modal.Footer className="border-0">
        {btnNoText && handlerNo && (
          <>
            <Button variant="btn btn-outline-primary" data-testid="confirmation-no-btn" onClick={handlerNo}>
              {btnNoText}
            </Button>
          </>
        )}

        <Button variant="primary" data-testid="confirmation-yes-btn" onClick={handlerYes}>
          {btnYesText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
